import { WidgetContext } from "@/shared/environment/widgets/widget-context.ts";
import { SearchContext } from "@/shared/search/search.types.ts";

export const getSearchContextByWidgetContext = (widgetContext: WidgetContext): SearchContext => {
    if (widgetContext.__type === "asset") {
        return {
            product: widgetContext.product,
            asset: widgetContext.asset,
        };
    }
    if (widgetContext.__type === "commonArticle") {
        return {
            article: widgetContext.articleId,
        };
    }
    if (widgetContext.__type === "mechanicArticle") {
        return {
            mechanic: widgetContext.mechanicId,
            product: widgetContext.product,
        };
    }
    if (widgetContext.__type === "product") {
        return {
            product: widgetContext.productId,
        };
    }

    console.error("Unknown widget", widgetContext.__type);
    return {};
};
